const initialState = {
  shifts : null,
  duties : null,
  signups : null,
  exchanges : null,
  events : null,
}

export default function reducer(state=initialState, action) {

  // console.log("Action");
  // console.log(action);
  // console.log('-----');
  //
  // console.log("Current state");
  // console.log(state);
  // console.log('-----');

  switch (action.type) {
    //TODO: make less ugly
    case "STORE_PRIVS": {
      return {
        ...state,
        events : {
          ...state.events,
          ...action.payload.events
        },
        shifts : {
          ...state.shifts,
          ...action.payload.shifts
        },
        signups : {
          ...state.signups,
          ...action.payload.signups
        },
        exchanges : {
          ...state.exchanges,
          ...action.payload.exchanges
        },
        duties : {
          ...state.duties,
          ...action.payload.duties
        }
      }
    }

  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/PrivilegeReducer.js